/* --------------------------------------------------------------------------------------
   xeroxEIPParameters.const.js
   Copyright © 2019 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const xeroxEIPParameters = {
  sides: [
    { key: 'OneSided', translationKey: 'ONE_SIDED', scope: ['scan', 'print'], img: "./img/2_sided_1_48.png"  },
    { key: 'TwoSided', translationKey: 'TWO_SIDED_LONG', scope: ['print'], img: "./img/2_sided_2_48.png"  },
    { key: 'TwoSidedShortEdge', translationKey: 'TWO_SIDED_SHORT', scope: ['print'], img: "./img/2_sided_rotate_48.png"  },
    { key: 'TwoSided', translationKey: 'TWO_SIDED_LONG', scope: ['scan'], img: "./img/2_sided_2_48.png"  },
    { key: 'SecondSideRotation', translationKey: 'TWO_SIDED_SHORT', scope: ['scan'], img: "./img/2_sided_rotate_48.png"  }
  ],
  resolutions: [
    { key: '72', value: '72 dpi', img: "./img/resolution_72_48.png" },
    { key: '100', value: '100 dpi', img: "./img/resolution_100_48.png" },
    { key: '150', value: '150 dpi', img: "./img/resolution_150_48.png" },
    { key: '200', value: '200 dpi', img: "./img/resolution_200_48.png" },
    { key: '300', value: '300 dpi', img: "./img/resolution_300_48.png" },
    { key: '400', value: '400 dpi', img: "./img/resolution_400_48.png" },
    { key: '600', value: '600 dpi', img: "./img/resolution_600_48.png" }
  ],
  scanColorModes: [
    { key: 'Auto', translationKey: 'AUTO_DETECT', img: "./img/output_color_auto_48.png" },
    { key: 'Fullcolor', translationKey: 'FULL_COLOR', img: "./img/output_color_color_48.png" },
    { key: 'BlackAndWhite', translationKey: 'BLACK_AND_WHITE', img: "./img/output_color_bw_48.png" },
    { key: 'Grayscale', translationKey: 'GRAYSCALE', img: "./img/output_color_gray_48.png" }
  ],
  printColorModes: [
    { key: 'Auto', translationKey: 'AUTO_DETECT', img: "./img/output_color_auto_48.png" },
    { key: 'Color', translationKey: 'FULL_COLOR', img: "./img/output_color_color_48.png" },
    { key: 'MonochromeGrayscale', translationKey: 'GRAYSCALE', img: "./img/output_color_gray_48.png" }
  ],
  orientations: [
    { key: 'Portrait', translationKey: 'PORTRAIT', img: "./img/orientation_portrait_48.png" },
    { key: 'Landscape', translationKey: 'LANDSCAPE', img: "./img/orientation_landscape_48.png" },
  ],
  sizes: [
    { key: 'NA_8.5x11SEF', value: '8.5 x 11"', orientation: 'P' },
    { key: 'NA_8.5x11LEF', value: '8.5 x 11"', orientation: 'L' },
    { key: 'NA_8.5x14LEF', value: '8.5 x 14"', orientation: 'L' },
    { key: 'NA_11x17LEF', value: '11 x 17"', orientation: 'L' },
    { key: 'NA_5.5x8.5SEF', value: '5.5 x 8.5"', orientation: 'P' },
    { key: 'NA_5.5x8.5LEF', value: '5.5 x 8.5"', orientation: 'L' },
    { key: 'NA_8.5x13LEF', value: '8.5 x 13"', orientation: 'L' },
    { key: 'ISO_A4SEF', value: 'A4', orientation: 'P' },
    { key: 'ISO_A4LEF', value: 'A4', orientation: 'L' },
    { key: 'ISO_A3LEF', value: 'A3', orientation: 'L' },
    { key: 'ISO_A5SEF', value: 'A5', orientation: 'P' },
    { key: 'ISO_A5LEF', value: 'A5', orientation: 'L' },
    { key: 'ISO_B4LEF', value: 'B4', orientation: 'L' },
    { key: 'ISO_B5SEF', value: 'B5', orientation: 'P' },
    { key: 'ISO_B5LEF', value: 'B5', orientation: 'L' }
  ],
  types: [
    { key: 'PhotoAndText', translationKey: 'TEXT_AND_PHOTO', img: "./img/original_type_text_photo_48.png" },
    { key: 'Text', translationKey: 'TEXT', img: "./img/original_type_text_48.png" },
    { key: 'Photo', translationKey: 'PHOTOGRAPH', img: "./img/original_type_photograph_48.png" },
    { key: 'Photocopy', translationKey: 'PHOTOCOPY', img: "./img/original_type_photocopied_48.png" },
    { key: 'PrintedPhotograph', translationKey: 'PRINTED_PHOTOGRAPH', img: "./img/original_type_printed_48.png" },
    { key: 'NewspaperOrMagazine', translationKey: 'NEWSPAPER_MAGAZINE', img: "./img/original_type_newspaper_48.png" }
  ],
  stapleOptions: [
    { key: 'Staple', translationKey: 'ON', img: "./img/orientation_portrait_48.png" },
    { key: 'None', translationKey: 'OFF', img: "./img/orientation_portrait_48.png" },
  ]
}



// WEBPACK FOOTER //
// ./src/app/constants/xeroxEIPParameters.const.js